/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Button } from "@nordcloud/gnui";

export const InlineActionButton = styled(Button)`
  margin: 0;
  border-radius: 22px;
  padding: 0.3rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;
